import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';


export class WarehouseTransferLine extends BaseEntity {
  
  warehouseTransferCode     : string;
  product                   : Product;
  productBatchCode          : string = "?";
  quantity                  : number = 0;
  returnedQuantity          : number = 0;
  returnedDamagedQuantity1  : number = 0;
  returnedDamagedQuantity2  : number = 0;
  
  constructor() {
    super()
  }
 
}
 


